<div>
  <form
    [formGroup]="typedSignatureForm"
    class="flex gap-x-3 mb-5"
    [appSectionLock]="Section.ESTATE">
    <div class="w-3/4">
      <app-ccs-input
        size="sm"
        formControlName="type_name"
        label="Type Name"
        placeholder="Enter type name" />
    </div>
    <app-ccs-select
      formControlName="font"
      label="Font"
      [options]="fontsOptions"
      placeholder="Select an option"
      valueKey="value"
      displayKey="label" />
  </form>
  <div class="border border-gray-300">
    <canvas class="w-full h-full" #textCanvas></canvas>
  </div>
</div>
